module.exports = __webpack_public_path__ + "static/media/implantes.e02dd3c7.png";